<template>
    <div>
        <div class="row mb-3">
            <div class="col-4">
                <search-client
                    size="sm"
                    :show-label="false"
                    show-feedback="false"
                    @client-is-set="setClientId"
                    @searching-client="resetClient"
                />
            </div>
        </div>
        <WebDataRocks
            v-if="pivotDisplay"
            :key="key"
            :report="pivotConfig"
            :global="pivotGlobal"
            toolbar
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import webDataRocksFrLocalization from '../../../../../../lang/fr/webDataRocksFrLocalization.json'
import WebDataRocks from '../../../common/components/WebDataRocks'
import SearchClient from '../../../activity_management/clients/components/SearchClient'

export default {
    name: 'EvolutionPivotClient',

    components: {
        WebDataRocks,
        SearchClient,
    },

    data() {
        return {
            clientIsSet: false,
            client_id: 0,
            pivotDisplay: false,
            pivotConfig: {
                dataSource: {},
                slice: {},
                options: {
                    grid: {
                        type: 'classic',
                        title: '',
                        showFilter: true,
                        showHeaders: false,
                        showTotals: true,
                        showGrandTotals: 'columns',
                        showHierarchies: true,
                        showHierarchyCaptions: true,
                        showReportFiltersArea: true,
                    },
                    configuratorActive: false,
                    configuratorButton: true,
                    showAggregations: true,
                    showCalculatedValuesButton: true,
                    drillThrough: true,
                    showDrillThroughConfigurator: true,
                    sorting: 'on',
                    datePattern: 'yyyy-MM-dd',
                    dateTimePattern: 'dd/MM/yyyy HH:mm:ss',
                    saveAllFormats: false,
                    showDefaultSlice: true,
                    defaultHierarchySortName: 'asc',
                },
                formats: [
                    {
                        name: '',
                        thousandsSeparator: ' ',
                        decimalSeparator: '.',
                        decimalPlaces: 0,
                        maxSymbols: 20,
                        currencySymbol: '€',
                        currencySymbolAlign: 'right',
                        nullValue: ' ',
                        infinityValue: 'Infinity',
                        divideByZeroValue: 'Infinity',
                    },
                ],
            },

            pivotGlobal: {
                localization: webDataRocksFrLocalization,
            },

            pivotData: null,

            key: 'wrd',
            ready: false,
        }
    },

    methods: {
        showPivot() {
            this.pivotDisplay = true
        },

        hidePivot() {
            this.pivotDisplay = false
        },

        async setClientId(client) {
            this.client_id = client.id
            this.clientIsSet = true
            await this.getData()
            this.showPivot()
            this.updateKey()
        },

        resetClient() {
            this.client_id = 0
            this.clientIsSet = false
            this.hidePivot()
        },

        updateKey() {
            this.key = Date.now()
        },

        async getData() {
            try {
                const response = await axios.get(
                    `/dashboard/evolution/pivot/${this.year}/${this.client_id}`
                )
                this.pivotData = response.data.data
                this.setInitialReport()
            } catch (error) {
                console.log(error)
            }
        },

        setInitialReport() {
            this.ready = false
            this.pivotConfig.dataSource = { data: this.pivotData }
            this.pivotConfig.slice = {
                rows: [
                    { uniqueName: 'Date.Month' },
                    { uniqueName: 'Activité', sort: 'asc' },
                ],
                columns: [{ uniqueName: 'An', sort: 'desc' }],
                measures: [{ uniqueName: 'Montant', aggregation: 'sum' }],
                expands: {
                    expandAll: false,
                },
                drills: {
                    drillAll: false,
                },
            }
            this.ready = true
            this.key = Date.now()
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
        }),
    },
}
</script>

<style scoped></style>
